// extracted by mini-css-extract-plugin
export var filterIncDec = "_a6-0";
export var leftBorder = "_a6-1";
export var rightBorder = "_a6-2";
export var stringInput = "_a6-3";